import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import {Nav, Navbar } from "react-bootstrap";
import Routes from "./Routes";
import "./App.css";
import { LinkContainer } from "react-router-bootstrap";
import { Auth } from "aws-amplify";

class App extends Component {
  
  constructor(props) {
    super(props);
  
    this.state = {
      isAuthenticated: false,
      isAuthenticating: true
    };
  }
  
  async componentDidMount() {
    try {
      await Auth.currentSession();
      this.userHasAuthenticated(true);
    } catch (e) {
      if (e !== 'No current user'){
        alert(e);
      }
    }
    this.setState({ isAuthenticating: false });
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
    this.props.history.push(`${process.env.PUBLIC_URL}/home`); 
  }

  handleLogout = async event => {
    await Auth.signOut();
    this.userHasAuthenticated(false);
    this.props.history.push(`${process.env.PUBLIC_URL}/login`);
  }

  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated
    };
    return (
      !this.state.isAuthenticating &&
      <div className="App container">

          <Navbar bg="dark" expand="lg" variant="dark">
          <LinkContainer to={`${process.env.PUBLIC_URL}/home`}>
            <Navbar.Brand className="brand"> sleep tracker</Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end navText">
            <Nav>
              {this.state.isAuthenticated
                ? <Nav.Item onClick={this.handleLogout}>Logout</Nav.Item>
                : <Fragment>
                    <LinkContainer to={`${process.env.PUBLIC_URL}/signup`}>
                      <Nav.Item>Signup</Nav.Item>
                    </LinkContainer>
                    <div className="divider"></div>
                    <LinkContainer to={`${process.env.PUBLIC_URL}/login`}>
                      <Nav.Item>Login</Nav.Item>
                    </LinkContainer>
                  </Fragment>
              }
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <Routes childProps={childProps} />
        
      </div>
    );
  }
}



export default withRouter(App);
